import { jsx as _jsx } from "react/jsx-runtime";
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
const PartialDesignDynamicPlaceholder = (props)=>/*#__PURE__*/ _jsx(PlaceholderWrapper, {
        name: props.rendering?.params?.sig || '',
        rendering: props.rendering
    });
export default PartialDesignDynamicPlaceholder;
